import * as React from 'react';
import t from 'utils/translations';
import { Select } from 'antd';
import styled from 'styled-components';
import { SelectProps } from 'antd/es/select';
import { useState } from 'react';

const { Option } = Select;

const FigureSelect = styled(Select)`
    &.ant-select {
        width: 150px;
        margin-right: 10px;
    }
`;

export const keyFigureInfoArray: KeyFigureInfo[] = [
    {
        key: 'TURNOVER',
        explanation: 'TURNOVER_EXPLANATION_GRAPH',
        dataFieldName: 'turnover',
        sizeFieldName: 'sampleSize',
        suffix: '€'
    },
    {
        key: 'TURNOVER_GROWTH_PERCENT_GRAPH',
        explanation: 'TURNOVER_GROWTH_PERCENT_EXPLANATION_GRAPH',
        dataFieldName: 'turnoverGrowthPercent',
        sizeFieldName: 'sampleSize',
        suffix: '%'
    },
    {
        key: 'RETURN_ON_INVESTMENT_GRAPH',
        explanation: 'RETURN_ON_INVESTMENT_EXPLANATION_GRAPH',
        dataFieldName: 'returnOnInvestmentPercent',
        sizeFieldName: 'sampleSize',
        suffix: '%'
    },
    {
        key: 'NET_PROFIT_PER_TURNOVER_GRAPH',
        explanation: 'NET_PROFIT_PER_TURNOVER_EXPLANATION_GRAPH',
        dataFieldName: 'netProfitPerTurnover',
        sizeFieldName: 'sampleSize',
        suffix: ' %'
    },
    {
        key: 'NET_PROFIT_GRAPH',
        explanation: 'NET_PROFIT_EXPLANATION_GRAPH',
        dataFieldName: 'netProfit',
        sizeFieldName: 'sampleSize',
        suffix: '€'
    },
    {
        key: 'CURRENT_RATIO_GRAPH',
        explanation: 'CURRENT_RATIO_EXPLANATION_GRAPH',
        dataFieldName: 'currentRatio',
        sizeFieldName: 'sampleSize',
        suffix: ''
    },
    {
        key: 'EQUITY_RATIO_GRAPH',
        explanation: 'EQUITY_RATIO_EXPLANATION_GRAPH',
        dataFieldName: 'equityRatio',
        sizeFieldName: 'sampleSize',
        suffix: '%'
    }
];

const getSelectedKeyFigureInfo = (selectedKeyFigure: string) => {
    const selectedKeyFigureInfo = keyFigureInfoArray.find(
        fig => fig.key === selectedKeyFigure
    );

    if (selectedKeyFigureInfo) return selectedKeyFigureInfo;
    console.warn(
        `Key figure with translation key ${selectedKeyFigure} does not exist.`
    );
    return keyFigureInfoArray[0];
};

export interface KeyFigureInfo {
    key: string;
    explanation: string;
    dataFieldName: string;
    sizeFieldName: string;
    suffix: string;
}

interface Props extends SelectProps {
    setKeyFigureInfo: (keyFigureInfo: KeyFigureInfo) => void;
}

export const KeyFigureSelector = (props: Props) => {
    const changeFigure = (value: string) => {
        props.setKeyFigureInfo(getSelectedKeyFigureInfo(value));
    };

    return (
        <FigureSelect
            {...props}
            defaultValue={keyFigureInfoArray[0].key}
            onChange={changeFigure}
            size="small"
        >
            {keyFigureInfoArray.map(figure => (
                <Option key={figure.key} value={figure.key}>
                    {t(figure.explanation)}
                </Option>
            ))}
        </FigureSelect>
    );
};
